import { format } from "date-fns";
import moment from "moment";

export const formatDate = (dateMs: Date | number | undefined, formatString: string = "dd.LL") => {
    if (dateMs) return format(dateMs, formatString);
    else return '';
}

export const formatDateWithTemplate = (date: number, format: string = "D MMM", locale = 'ru') => moment(date).locale(locale).format(format)